import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectTriggeredHints } from '../../reducers/user.selectors';
import { computeGrade, type Grade } from './grade';
import { type ReportCardAreaId, reportCardAreas } from './reportCard.config';

export interface TrialReportCardProgress {
	completionByArea: Record<ReportCardAreaId, boolean>;
	completedCount: number;
	grade: Grade;
}

/**
 * Derives Trial Report Card progress from the server-backed triggered-hint list
 * (WOR-795): per-area completion, the completed count, and the overall grade.
 */
export function useTrialReportCardProgress(): TrialReportCardProgress {
	const triggeredHints = useSelector(selectTriggeredHints);
	return useMemo(() => {
		const completionByArea = reportCardAreas.reduce(
			(acc, area) => {
				acc[area.id] = triggeredHints.includes(area.hintKey);
				return acc;
			},
			{} as Record<ReportCardAreaId, boolean>
		);

		const completedCount = Object.values(completionByArea).filter(Boolean).length;

		return { completionByArea, completedCount, grade: computeGrade(completedCount) };
	}, [triggeredHints]);
}
